import React, { useState } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-night-600/40 rounded-xl overflow-hidden" data-id="element-26">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left hover:bg-night-700/30 transition-colors duration-200" aria-expanded={isOpen} data-id="element-27">
        <span className="font-dm-sans text-base sm:text-lg font-medium text-cream-100" data-id="element-28">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-cream-200/50 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-29" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
        <p className="px-5 sm:px-6 pb-5 sm:pb-6 font-dm-sans text-sm sm:text-base text-cream-200/60 leading-relaxed" data-id="element-31">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="relative bg-night-900 py-20 md:py-28 overflow-hidden" data-id="element-32">
      <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8" data-id="element-33">
        <AnimatedSection data-id="element-34">
          <h2 className="font-playfair text-3xl sm:text-4xl font-bold text-cream-100 mb-12 text-center" data-id="element-35">
            Preguntas frecuentes
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={100} data-id="element-36">
          <div className="space-y-3" data-id="element-37">
            <FAQItem question="¿Sirve para bebés de cualquier edad?" answer="Sí, está diseñado para el rango de 0 a 24 meses ajustando las ventanas de tiempo según la etapa de desarrollo de tu bebé." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-38" />
            <FAQItem question="¿Tengo que comprar accesorios caros?" answer="No, usamos lo que ya tienes en casa para ajustar luz y temperatura. No necesitas invertir en productos adicionales." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-39" />
            <FAQItem question="¿Es seguro para la lactancia?" answer="Totalmente. El método respeta las tomas necesarias pero elimina la dependencia de la succión para dormir, permitiendo una lactancia saludable." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-40" />
            <FAQItem question="¿Qué pasa si mi casa es ruidosa?" answer="Incluimos el Mapa de Ruidos Blancos para crear un escudo de sonido que protege el sueño de tu bebé sin importar el entorno." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-41" />
            <FAQItem question="¿Cuándo veré resultados?" answer="Los primeros ajustes en la facilidad para dormir se notan desde la noche 3. El cambio completo se consolida en 7 días." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-42" />
          </div>
        </AnimatedSection>
      </div>
    </section>;
}